export default function Configure($stateProvider) {
    $stateProvider.state('proprietaires', {
        parent: 'common',
        url: '/proprietaires',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.DONNEES_PARAMETRES" | translate }}'
        }
    });

    $stateProvider.state('proprietaires.list', {
        url: '/:genre/list',
        template: '<sites></sites>',
        rights: { domain: 'siteproprio', right: 'read', application: 'qse' },
        ncyBreadcrumb: {
            label: '{{ "SITES.BREADCRUMBS.SITES_PROPRIETAIRES_LIST" | translate}}'
        }
    });

    $stateProvider.state('proprietaires.niveaux', {
        url: '/:genre/niveaux',
        template: '<site-config-niveaux></site-config-niveaux>',
        rights: { domain: 'nivh', right: 'read' },
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher sites > niveaux
            parent: 'proprietaires.list({genre: "proprietaires"})',
            label: '{{ "SITES.BREADCRUMBS.SITE_NIVEAUX" | translate }}'
        }
    });

    $stateProvider.state('proprietaires.list.detail', {
        url: '/:genre/{id}',
        template: '<site-detail></site-detail>',
        ncyBreadcrumb: {
            parent: 'proprietaires.list({genre: "proprietaires"})',
            label: '{{ "SITES.BREADCRUMBS.SITE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('proprietaires.new', {
        url: '/:genre/new',
        template: '<site-form></site-form>',
        rights: { domain: 'siteproprio', right: 'create' },
        ncyBreadcrumb: {
            parent: 'proprietaires.list({genre: "proprietaires"})',
            label: '{{ "SITES.BREADCRUMBS.SITE_NEW_PROPRIETAIRE" | translate}}'
        },
        search: 'SITES.BREADCRUMBS.SITE_NEW_PROPRIETAIRE'
    });

    $stateProvider.state('proprietaires.edit', {
        url: '/:genre/{id}/edit',
        template: '<site-form></site-form>',
        rights: { domain: 'siteproprio', right: 'update' },
        ncyBreadcrumb: {
            parent: 'proprietaires.list({genre: "proprietaires"})',
            label: '{{ "SITES.BREADCRUMBS.SITE_EDIT_PROPRIETAIRE" | translate }}'
        }
    });
}

Configure.$inject = ['$stateProvider'];
